import { createDivIn } from '../../ui_utils/DomUtils.ts';
export class UIGameFeed {
    scale(zoom) {
        this.mainBlock.style.transform = `scale(${zoom})`;
    }
    setWidth(width) {
        this.container.style.width = width + 'px';
    }
    setHeight(height) {
        this.container.style.height = height + 'px';
    }
    setPositionLeft(offset) {
        this.mainBlock.style.left = offset + 'px';
    }
    setPositionRight(offset) {
        this.mainBlock.style.right = offset + 'px';
    }
    setPositionTop(offset) {
        this.mainBlock.style.top = offset + 'px';
    }
    setPositionBottom(offset) {
        this.mainBlock.style.bottom = offset + 'px';
    }
    setVisibility(visible) {
        this.mainBlock.style.visibility = visible ? 'visible' : 'hidden';
    }
    setFullWidth() {
        this.mainBlock.style.width = '100%';
    }
    constructor(containerId, mainBlockClass, containerClass){
        this.mainBlock = createDivIn(document.body, 'main_block ' + (mainBlockClass || ''));
        this.container = createDivIn(this.mainBlock, 'game_chat_text_div ' + (containerClass || ''), containerId);
        this.mainBlock.style.position = 'absolute';
    }
}
